/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/CollectionLabel/Content/History/Content/Content/Entry/Author"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let entryCreatedByPersonValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_by_person',
format: fromFormat.personName,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Author.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2ksb3n': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="By"
 color={dtColorsNeutral400}
 size="small"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="entry.created_by_person"
 format="/Data/format.js personName"
 text={entryCreatedByPersonValueData}
 color={dtColorsNeutral600}
/>
</div>
{children}
</React.Fragment>)
}